const grabAndScrollAll = document.querySelectorAll('.grabAndScroll');

/**
 * Adiciona os listeners pra cada elemento
 */
function addGrabAndScrollHandler(grabAndScroll) {
  let pos = { top: 0, left: 0, x: 0, y: 0 };

  /**
   * Atualiza as posições do scroll baseado no movimento do mnouse
   */
  function mouseMoveHandler(e) {
    const dx = e.clientX - pos.x;
    const dy = e.clientY - pos.y;

    grabAndScroll.scrollTop = pos.top - dy;
    grabAndScroll.scrollLeft = pos.left - dx;
  }

  /**
   * Atualiza os listeners e atualiza o estado do cursor
   */
  function mouseUpHandler() {
    document.removeEventListener('mousemove', mouseMoveHandler);
    document.removeEventListener('mouseup', mouseUpHandler);

    grabAndScroll.style.cursor = 'grab';
    grabAndScroll.style.removeProperty('user-select');
  };

  /**
   * Lida com o evento de mouse down para o scroll vertical ou lateral
   */
  function mouseDownHandler(e) {
    grabAndScroll.style.cursor = 'grabbing';
    grabAndScroll.style.userSelect = 'none';
    pos = {
      left: grabAndScroll.scrollLeft,
      top: grabAndScroll.scrollTop,
      x: e.clientX,
      y: e.clientY,
    };

    document.addEventListener('mousemove', mouseMoveHandler);
    document.addEventListener('mouseup', mouseUpHandler);
  };

  grabAndScroll.scrollTop = 100;
  grabAndScroll.scrollLeft = 150;
  grabAndScroll.addEventListener('mousedown', mouseDownHandler);
};

/**
 * Aplica o listener para click dos elementos grab and scroll
 */
function applyListeners() {
  if (grabAndScrollAll) {
    grabAndScrollAll.forEach((element) => {
      addGrabAndScrollHandler(element);
    });
  }
}

module.exports = {
  init: applyListeners,
  handler: addGrabAndScrollHandler
};
